export default "__VITE_ASSET__BOzlNJsz__"